import styled, { css } from 'styled-components';

export default styled.button`
  ${({ theme, useDefaultTheme }) => {
    return css`
      ${useDefaultTheme &&
      css`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin: 16px 0 0 0;
        padding: 8px 16px;
        border-radius: 3px;
        border: 1px solid ${theme.colors.border};
        font-family: inherit;
        transition: opacity 200ms ease;
        &:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          border-color: ${theme.colors.light_grey_light};
          background: ${theme.colors.light_grey_light};
          color: ${theme.colors.light_grey_dark};
          svg {
            margin-left: 4px;
            circle {
              stroke: ${theme.colors.light_grey_dark};
            }
          }
        }
        &:hover {
          opacity: 0.7;
        }
      `}
    `;
  }};
`;
